import http from './http';
import type { IReglamento, IReglamentoForm } from '../models/reglamento_model';
import { base64ToFile } from './ticket_repository';
import type { AdjuntoBase64 } from 'models/adjunto_base64_model';

export const getReglamentosService = async (filtro?: {
  nombre?: string;
  limit: number;
  page: number;
}) => {
  try {
    const filters = [];
    if (filtro?.nombre) {
      filters.push(`title=${filtro.nombre}`);
    }
    filters.push(`_limit=${filtro?.limit}`);
    filters.push(`_page=${filtro?.page}`);
    return await http.get<{
      rows: IReglamento[];
      count: number;
    }>(
      `/reglamentos${filters.length ? '?' + filters.join('&') : ''}`,
    );
  } catch (error) {
    console.error('[get_reglamentos]  Error -> ', error);
    return {
      rows: [],
      count: 0,
    };
  }
};

export const createReglamentoService = async (data: IReglamentoForm) => {
  try {
    const formData = new FormData();
    formData.append('titulo', data.nombre);
    const adjuntos = data.archivo ? JSON.parse(data.archivo) as AdjuntoBase64[] : [];
    if (adjuntos.length > 0) {
      const file = adjuntos[0];
      const fileObject = base64ToFile(
        file.fileObject.data,
        file.fileName,
        file.fileType,
      );
      formData.append('file', fileObject);
    }

    return await http.post(`/reglamento`, formData, {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
    });
  } catch (error) {
    console.error('Ocurrio un error al guardar reglamento :: ', error);
    return null;
  }
};

export const editReglamentoService = async (
  data: IReglamentoForm,
  id: string,
) => {
  try {
    const formData = new FormData();
    formData.append('titulo', data.nombre);
    const adjuntos = data.archivo ? JSON.parse(data.archivo) as AdjuntoBase64[] : [];
    if (adjuntos.length > 0) {
      const file = adjuntos[0];
      const fileObject = base64ToFile(
        file.fileObject.data,
        file.fileName,
        file.fileType,
      );
      formData.append('file', fileObject);
    }

    return await http.put(`/reglamento/${id}`, formData, {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
    });
  } catch (error) {
    console.error('Ocurrió un error al editar reglamento :: ', error);
    return null;
  }
};

export const deleteReglamentoService = async (id: string) => {
  try {
    return await http.delete(`/reglamento/${id}`);
  } catch (error) {
    console.error('Error al eliminar reglamento :: ', error);
    return null;
  }
};

export const downloadFileReglamentoService = async (
  id: string,
  fileName: string,
) => {
  try {
    const response = await http.download(
      `/reglamento/${id}/download`,
      fileName,
    );
    return response;
  } catch (error) {
    console.error('Error al descargar el archivo del reglamento :: ', error);
    return null;
  }
};
